import React from 'react';
import InputError from './InputError';
import { useState } from 'react';

const InputToggle = ({ label, id, name, required, error }) => {
  const [toggleSwitch, setToggleSwitch] = useState(false);

  return (
    <div className="flex items-center">
      <label className="relative flex cursor-pointer select-none">
        <div
          className={`flex w-8 items-center rounded-full duration-default hover:cursor-pointer ${
            toggleSwitch ? 'bg-primary' : 'bg-grey'
          }`}
          onClick={() => setToggleSwitch(!toggleSwitch)}
        >
          <div
            className={`my-0.8 m-0.5 h-3.5 w-3.5 rounded-full bg-white opacity-80 drop-shadow-default duration-default ease-in-out ${
              toggleSwitch ? 'translate-x-3.5' : 'translate-x-0'
            }`}
          ></div>
        </div>
        <input
          className="absolute h-0 w-0"
          type="checkbox"
          name={name}
          id={id}
          aria-label={name}
          required={required}
        />
      </label>
      <span className="text-xs">{label}</span>
      <InputError id={id} error={error} />
    </div>
  );
};

export default InputToggle;
